import { escapeRegExp } from "lodash";
import React from "react";
import cx from "classnames";

import s from "./Highlighted.module.scss";

export default function Highlighted({
	text = "",
	highlight = "",
	className = "",
	onClick = () => {},
}) {
	//TODO: !!!! optimize, this is very slow
	const regex = highlight != null && highlight.length > 0 ? new RegExp(`(${escapeRegExp(highlight)})`, "gi") : null;
	const parts = text != null && regex != null ? text.split(regex): [ text ];

	return (
		<div onClick={onClick} className={cx(s.root, className)}>
			{parts
				.filter((part) => part)
				.map((part, i) => (
					<span
						className={highlight.trim() && regex.test(part) ? s.highlight : ""}
						key={i}
					>
						{part}
					</span>
				))}
		</div>
	);
}
